export let ISettingsParamsBooleansKeys = /*#__PURE__*/function (ISettingsParamsBooleansKeys) {
  ISettingsParamsBooleansKeys["flipImageAndTextRatio"] = "flipImageAndTextRatio";
  ISettingsParamsBooleansKeys["isTitleVisible"] = "isTitleVisible";
  ISettingsParamsBooleansKeys["isListFilterVisible"] = "isListFilterVisible";
  ISettingsParamsBooleansKeys["isServiceImageVisible"] = "isServiceImageVisible";
  ISettingsParamsBooleansKeys["isListFilterStretched"] = "isListFilterStretched";
  ISettingsParamsBooleansKeys["isServicesDividerVisible"] = "isServicesDividerVisible";
  ISettingsParamsBooleansKeys["isOnlineBadgeVisible"] = "isOnlineBadgeVisible";
  ISettingsParamsBooleansKeys["isTagLineVisible"] = "isTagLineVisible";
  ISettingsParamsBooleansKeys["isMoreInfoButtonVisible"] = "isMoreInfoButtonVisible";
  ISettingsParamsBooleansKeys["isServiceDividerVisible"] = "isServiceDividerVisible";
  ISettingsParamsBooleansKeys["isServiceOfferedDaysVisible"] = "isServiceOfferedDaysVisible";
  ISettingsParamsBooleansKeys["isServiceStartDateVisible"] = "isServiceStartDateVisible";
  ISettingsParamsBooleansKeys["isCourseAvailabilityVisible"] = "isCourseAvailabilityVisible";
  ISettingsParamsBooleansKeys["displayNumberOfSpots"] = "displayNumberOfSpots";
  ISettingsParamsBooleansKeys["isServiceDurationVisible"] = "isServiceDurationVisible";
  ISettingsParamsBooleansKeys["isServicePriceVisible"] = "isServicePriceVisible";
  ISettingsParamsBooleansKeys["isBookButtonVisible"] = "isBookButtonVisible";
  ISettingsParamsBooleansKeys["isExplorePlansVisible"] = "isExplorePlansVisible";
  ISettingsParamsBooleansKeys["showAllServicesFilterOption"] = "showAllServicesFilterOption";
  return ISettingsParamsBooleansKeys;
}({}); // CATEGORY_ALL_SERVICES_SHOW
export let ISettingsParamsNumbersKeys = /*#__PURE__*/function (ISettingsParamsNumbersKeys) {
  ISettingsParamsNumbersKeys["cardsPerRow"] = "cardsPerRow";
  ISettingsParamsNumbersKeys["cardSpacing"] = "cardSpacing";
  ISettingsParamsNumbersKeys["gridCardsSpacing"] = "gridCardsSpacing";
  ISettingsParamsNumbersKeys["servicesDividerWidth"] = "servicesDividerWidth";
  ISettingsParamsNumbersKeys["stripCardSpacing"] = "stripCardSpacing";
  return ISettingsParamsNumbersKeys;
}({}); // STRIP_SPACE_BETWEEN_OFFERINGS
export let ISettingsParamsTextKeys = /*#__PURE__*/function (ISettingsParamsTextKeys) {
  ISettingsParamsTextKeys["allServices"] = "allServices";
  ISettingsParamsTextKeys["bookButtonText"] = "bookButtonText";
  ISettingsParamsTextKeys["explorePlansText"] = "explorePlansText";
  ISettingsParamsTextKeys["viewCourseButtonText"] = "viewCourseButtonText";
  ISettingsParamsTextKeys["moreInfoButtonText"] = "moreInfoButtonText";
  ISettingsParamsTextKeys["noBookFlowText"] = "noBookFlowText";
  ISettingsParamsTextKeys["onlineBadgeText"] = "onlineBadgeText";
  ISettingsParamsTextKeys["pendingApprovalText"] = "pendingApprovalText";
  ISettingsParamsTextKeys["titleText"] = "titleText";
  ISettingsParamsTextKeys["courseAvailabilityText"] = "courseAvailabilityText";
  ISettingsParamsTextKeys["courseAvailableText"] = "courseAvailableText";
  ISettingsParamsTextKeys["courseNoAvailabilityText"] = "courseNoAvailabilityText";
  return ISettingsParamsTextKeys;
}({}); // COURSE_NO_AVAILABILITY_TEXT
export let ISettingsParamsCustomsKeys = /*#__PURE__*/function (ISettingsParamsCustomsKeys) {
  ISettingsParamsCustomsKeys["bookButtonStyle"] = "bookButtonStyle";
  ISettingsParamsCustomsKeys["filterLayout"] = "filterLayout";
  ISettingsParamsCustomsKeys["filterServicesBy"] = "filterServicesBy";
  ISettingsParamsCustomsKeys["displayServicesBy"] = "displayServicesBy";
  ISettingsParamsCustomsKeys["listFilterAlignment"] = "listFilterAlignment";
  ISettingsParamsCustomsKeys["textAlignment"] = "textAlignment";
  ISettingsParamsCustomsKeys["titleAlignment"] = "titleAlignment";
  ISettingsParamsCustomsKeys["serviceListLayout"] = "serviceListLayout";
  ISettingsParamsCustomsKeys["serviceImagePosition"] = "serviceImagePosition";
  ISettingsParamsCustomsKeys["serviceImageShape"] = "serviceImageShape";
  ISettingsParamsCustomsKeys["serviceImageResize"] = "serviceImageResize";
  ISettingsParamsCustomsKeys["serviceImageDockLocation"] = "serviceImageDockLocation";
  ISettingsParamsCustomsKeys["serviceClickTarget"] = "serviceClickTarget";
  return ISettingsParamsCustomsKeys;
}({}); // SERVICE_CLICK_TARGET
//# sourceMappingURL=settingsParamsKeys.js.map